var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "hide")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,25.43a1.41,1.41,0,1,1,0-2.81c9.8,0,15.66-9.59,15.72-9.69a1.41,1.41,0,0,1,2.42,1.45C37.86,14.83,31.38,25.43,20,25.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,33a1.41,1.41,0,0,1-1.41-1.41V24a1.41,1.41,0,0,1,2.82,0v7.53A1.41,1.41,0,0,1,20,33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.55,30.07a1.41,1.41,0,0,1-1.25-.76L26,23a1.41,1.41,0,0,1,2.49-1.31L31.79,28a1.42,1.42,0,0,1-1.24,2.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.29,24.3a1.41,1.41,0,0,1-.87-.3L31.9,19.7a1.41,1.41,0,1,1,1.73-2.23l5.53,4.3a1.42,1.42,0,0,1-.87,2.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25.43c-11.38,0-17.87-10.6-18.14-11a1.41,1.41,0,0,1,2.42-1.45c.06.1,6,9.69,15.72,9.69a1.41,1.41,0,1,1,0,2.81Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45,30.07A1.42,1.42,0,0,1,8.21,28l3.31-6.28A1.41,1.41,0,1,1,14,23L10.7,29.31A1.41,1.41,0,0,1,9.45,30.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71,24.3a1.41,1.41,0,0,1-.86-2.53l5.52-4.3A1.41,1.41,0,0,1,8.1,19.7L2.58,24A1.41,1.41,0,0,1,1.71,24.3Z"
  })));
}

export default SvgHide;